import styled from "styled-components";

export const GoogleButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
  background: white;
  cursor: pointer;
  font-weight: 600;
`;
